import { Popover } from '@mantine/core';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import styles from './detail.scoped.css';

export default function PeriodFilterSelect({
  className = '',
  disabledValues = [],
  displayValue,
  label,
  onChange,
  options = [],
  placeholder = 'Pilih',
  value = '',
}) {
  const [opened, setOpened] = useState(false);

  const resolvedDisplayValue = useMemo(() => {
    if (displayValue !== undefined && displayValue !== null) {
      return displayValue;
    }

    if (!value) {
      return placeholder;
    }

    return options.find((option) => option.value === value)?.label || placeholder;
  }, [displayValue, options, placeholder, value]);

  const handleSelect = (nextValue) => {
    onChange(nextValue);
    setOpened(false);
  };

  return (
    <div className={[styles.periodFilterField, className].filter(Boolean).join(' ')}>
      <Popover
        onChange={setOpened}
        opened={opened}
        position="bottom-start"
        shadow="md"
        width="target"
        withArrow={false}
        withinPortal
        zIndex={1000}
      >
        <Popover.Target>
          <button
            className={styles.periodFilterTrigger}
            onClick={() => setOpened((current) => !current)}
            type="button"
          >
            <span className={styles.periodFilterText}>
              <span className={styles.periodFilterLabel}>{label}</span>
              <span
                className={[
                  styles.periodFilterValue,
                  value ? styles.periodFilterValueSelected : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                {resolvedDisplayValue}
              </span>
            </span>
            <span className={styles.periodFilterIcon}>
              <img alt="" aria-hidden="true" src="/assets/ic-arrow-updown.svg" />
            </span>
          </button>
        </Popover.Target>
        <Popover.Dropdown className={styles.periodFilterDropdown}>
          <div className={styles.periodFilterOptions}>
            {options.map((option) => {
              const isDisabled = disabledValues.includes(option.value);
              const isSelected = option.value === value;

              return (
                <button
                  className={[
                    styles.periodFilterOption,
                    isSelected ? styles.periodFilterOptionSelected : '',
                    isDisabled ? styles.periodFilterOptionDisabled : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  disabled={isDisabled}
                  key={option.value}
                  onClick={() => handleSelect(option.value)}
                  type="button"
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </Popover.Dropdown>
      </Popover>
    </div>
  );
}

PeriodFilterSelect.propTypes = {
  className: PropTypes.string,
  disabledValues: PropTypes.arrayOf(PropTypes.string),
  displayValue: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  placeholder: PropTypes.string,
  value: PropTypes.string,
};
